import { Fragment, useContext } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import "./App.css";
import BaseLayout from "./components/general/layout/base-layout";
import Error404 from "./pages/404";
import LoginPage from "./pages/login";
import RequireAuth from "./router/RequireAuth";
import { partnerRoutes, routes } from "./routes";
import { isSubset } from "./components/general/layout/side-bar";
import AuthContext from "./context/auth/context";
import PartnerLayout from "./components/general/layout/partner-layout";
import { Permissions } from "./utils/Permissions/Permissions";

function App() {
  const { userPermissions: permissions, userDetails: user } =
    useContext(AuthContext);
  let userPermissions =
    permissions?.length > 0
      ? permissions
      : localStorage?.getItem("permisionStoroge")?.split(",");
  if (!userPermissions) userPermissions = [];
  const protectedLayout = (
    <RequireAuth>
      {user?.roles[0]?.name === "TradeManager" ? (
        <Navigate to="/partner/home" replace />
      ) : (
        <BaseLayout />
      )}
    </RequireAuth>
  );

  const partnerLayout = (
    <RequireAuth>
      <PartnerLayout />
    </RequireAuth>
  );

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={protectedLayout}>
          {!userPermissions.includes(Permissions.CAN_VIEW_HOME_PAGE_TAB) &&
            userPermissions.includes(Permissions.CAN_VIEW_DAILY_STOCK_COUNTS) && (
              <Route index element={<Navigate to="/wms/daily-stock-counts" replace />} />
            )}
          {!userPermissions.includes(Permissions.CAN_VIEW_DAILY_STOCK_COUNTS) && !userPermissions.includes(Permissions.CAN_VIEW_HOME_PAGE_TAB) &&
            isSubset([
              Permissions.CAN_VIEW_GENERAL_DATA,
              Permissions.CAN_VIEW_TRADEMARK_TAB,
              Permissions.CAN_BULK_CHANGE_TRADEMARK_PRODUCT_STATUS,
            ], userPermissions) && (
              <Route index element={<Navigate to="/trademarks" replace />} />
            )}
          {routes.map((route, index) => {
            if (route.hasSubMenus === true) {
              return route.subMenus
                ?.filter((menu) => isSubset(menu.permissions, userPermissions))
                .map((menu, index) => {
                  if (menu.crudRoutes) {
                    return (
                      <Route key={index} path={menu.path} element={<Outlet />}>
                        {menu?.crudRoutes?.map((crudRoute, indexRoute) => {
                          return (
                            <Fragment key={index}>
                              <Route
                                key={index}
                                index
                                element={menu.component}
                              />
                              <Route
                                key={index}
                                path={`${crudRoute.path}`}
                                element={crudRoute.component}
                              />
                            </Fragment>
                          );
                        })}
                      </Route>
                    );
                  } else {
                    return (
                      <Route
                        key={index}
                        path={menu.path}
                        element={menu.component}
                      />
                    );
                  }
                });
            } else {
              if (isSubset(route.permissions, userPermissions)) {
                if (route.crudRoutes) {
                  return (
                    <Route key={index} path={route.path} element={<Outlet />}>
                      {route?.crudRoutes?.map((crudRoute, indexRoute) => {
                        return (
                          <Fragment key={index}>
                            <Route
                              key={index}
                              index
                              element={route.component}
                            />
                            <Route
                              key={indexRoute}
                              path={`${crudRoute.path}`}
                              element={crudRoute.component}
                            />
                          </Fragment>
                        );
                      })}
                    </Route>
                  );
                }
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.component}
                  />
                );
              }
            }
          })}
        </Route>
        <Route path="/partner/home" element={partnerLayout}>
          {partnerRoutes.map((route, index) => {
            if (isSubset(route.permissions, userPermissions)) {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={route.component}
                />
              );
            }
          })}
        </Route>
        <Route
          path="*"
          element={
            <>
              <Error404 />
            </>
          }
        />
      </Routes>
    </>
  );
}

export default App;
